import { CHANGE_SELECTED_SERVICE, SET_INITIAL_SERVICE, UPDATE_DASHBOARD_DATA } from '../actions/dashboard';

const initialState = {
  selectedService: null, // Will be set from user data
  dashboardData: {}, // keep non-null to avoid layout flicker
  loading: false,
  error: null
};

const dashboard = (state = initialState, action) => {
  switch (action.type) {
    case SET_INITIAL_SERVICE:
      return {
        ...state,
        selectedService: action.payload.service,
        loading: false
      };
    
    case CHANGE_SELECTED_SERVICE:
      return {
        ...state,
        selectedService: action.payload.service,
        // keep loading false; table handles its own loading indicator
        loading: false
      };
    
    case UPDATE_DASHBOARD_DATA:
      return {
        ...state,
        dashboardData: action.payload.data,
        loading: false,
        error: null
      };
    
    default:
      return state;
  }
};

export default dashboard;
